import { transformWikiResponse } from './domain/wikiResponseMapper.js';
import __vue_component__ from './WikiStructured.vue.js';
import { defineComponent } from '@vue/composition-api';

var script = defineComponent({
    name: 'Wiki',
    props: {
        wikiResponse: {
            type: [Object, String],
            required: true,
        },
        /**
         * If defined, it will be used to whitelist the host of the iframe in the Raw HTML block.
         * When not set, iframes will be filtered out.
         */
        htmlBlockIFrameHostWhitelist: {
            type: Array,
            required: false,
            default: undefined,
        },
    },
    computed: {
        wiki: function () {
            return transformWikiResponse(this.wikiResponse);
        }
    },
    components: {
        WikiStructured: __vue_component__,
    },
});

export default script;
